const images = [
  { id: 1, img: "./images/5.png" },
  { id: 2, img: "./images/2.png" },
  // { id: 3, img: "./images/3.png" },
  { id: 4, img: "./images/4.png" },
  { id: 5, img: "./images/1.png" },
  { id: 6, img: "./images/6.png" },
];

export default images;
